module.exports = __webpack_public_path__ + "img/d478716c26ed9837522e525cc60bcc0c.png";